// export const API_URL = 'http://localhost:3006';
// export const API_URL = 'http://192.168.0.51:3006';
// export const API_URL = 'https://srv702611.hstgr.cloud:3006';
export const token = () => sessionStorage.getItem('token');
// export const API_URL = 'https://tantak-elearning.onrender.com';
export const API_URL = 'https://educonnect-backend-t1tt.onrender.com';

